<template>
  <v-content class="gb">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12" class="top-container">
          <v-card :loading="status === 'loading'" class="fill-width table_theme card-theme custom-container">
            <v-card-title class="title_table medium-font" style="letter-spacing: normal">
              Users
              <v-spacer></v-spacer>
              <div
                  class="custom-o-search-bar"
                  style="right: -25px !important; left: auto !important;"
              >
                <v-text-field
                    v-model="search"
                    placeholder="Search..."
                    single-line
                    hide-details
                    class="input_search"
                    color="#198beb"
                >
                  <img
                      :src="require('@/assets/img/search.svg')"
                      slot="prepend"
                      alt="help"
                      class="info-tooltip"
                  />
                </v-text-field>
              </div>
<!--              <v-btn text class="custom-o-sliders">-->
<!--                <img :src="require('@/assets/img/settings.svg')" alt/>-->
<!--              </v-btn>-->
            </v-card-title>
            <div style="width: 100%;padding: 0px 13px;">
              <v-divider class="ma-0" style="max-width: 1071px;"></v-divider>
            </div>
            <template v-if="error">
              <div>
                <v-alert type="error" dense dismissible @input="error = false">{{ message_error }}</v-alert>
              </div>

            </template>
            <v-data-table
                v-model="selected"
                :headers="headers"
                :items="filteredItems"
                :search="search"
                color="#717e91"
                :multi-sort="false"
                item-key="id"
                show-select
                :hide-default-footer="true"
                :options.sync="options"
                class="employees-table"
            >
              <template v-slot:header.data-table-select="{ props, on }">
                <SelectCheckbox
                    :value="props.value"
                    :indeterminate="props.indeterminate"
                    @input="on.input($event)"
                />
              </template>
              <template v-slot:item.data-table-select="{ isSelected, select }">
                <SelectCheckbox
                    :value="isSelected"
                    @input="select($event)"
                />
              </template>
              <template v-slot:top>
                <div class="table_botonera">
                  <div class="drop-down-company">
                    <v-select
                        v-model="filters.status"
                        :items="statuses"
                        width="100px"
                        class="company-display ui-label ui-label--b pt-0 mr-4 xs-drop-down custom-select-options select-no-border"
                        color="#29ABE2"
                        placeholder="Status"
                        name="company_data"
                        type="text"
                        hide-details
                        item-value="id"
                        item-text="name"
                    >
                      <template v-slot:append>
                        <img
                            :src="require('@/assets/img/dropdown-triangle-blue.png')"
                            style="position: relative;"
                            alt
                            width="11px"
                            height="6px"
                        />
                      </template>
                    </v-select>
                  </div>
                  <v-btn
                      v-if="paymentPermission"
                      rounded
                      text
                      color="#29ABE2"
                      class="btn-blanco table_btn custom-o-white btn-border"
                      style="left:-4px;"
                      v-on:click="$router.push('/vendor/users/add-users')"
                  >Add New User
                  </v-btn>
                  <v-btn
                      rounded
                      text
                      color="#29ABE2"
                      class="btn-blanco table_btn custom-o-white btn-border"
                      style="left: 10px;width: 122px !important;"
                      @click="show_DeleteModal"
                      :disabled="allSelectedInactive"
                  >Delete
                  </v-btn>
                  <v-btn
                      v-if="paymentPermission"
                      rounded
                      text
                      color="#29ABE2"
                      class="btn-blanco table_btn custom-o-white btn-border"
                      style="left:24px;"
                      @click="show_ResendModal"
                      :disabled="allSelectedInactive"
                  >Resend Invite
                  </v-btn>
                </div>
              </template>
              <template v-slot:item.phone_number="{ item }">
                <div v-if="owner_selected === null || owner_selected !== item.owner_id" class="d-flex align-center">
                  <v-btn
                      depressed
                      @click="editItem(item)"
                      style="padding: 0; font-size: 10px; height: 16px; min-width: 24px; margin-right: 4px;"
                      :id="'btn_'+ item.owner_id"
                  >Edit
                  </v-btn>
                  <span :id="'span_'+item.owner_id">{{ item.phone_number }}</span>
                </div>
                <div v-else class="d-flex align-center">
                  <v-text-field
                      v-mask="mask"
                      class="input_field_phone_number"
                      :id="'value_'+item.owner_id"
                      name="new_phone_number"
                      v-model="phone_selected"
                      dense
                      hide-details
                      style="max-width: 130px;"
                  ></v-text-field>
                  <v-btn
                      depressed
                      @click="saveItem(item)"
                      style="padding: 0; font-size: 10px; height: 16px; min-width: 28px; margin-left: 4px;"
                      :id="'btn_save_'+ item.owner_id"
                  >Save
                  </v-btn>
                  <v-btn
                      depressed
                      @click="cancelItem()"
                      style="padding: 0; font-size: 10px; height: 16px; min-width: 38px; margin-left: 2px;"
                      :id="'btn_cancel_'+ item.owner_id"
                  >Cancel
                  </v-btn>
                </div>
              </template>

              <template v-slot:item.status="{ item }">
                <span
                    class="text-xs-right table-f"
                    style="text-transform: capitalize; width: 100% !important; display: inline-block !important;"
                >
                  <v-icon
                      class="status-icon custom-status-icon"
                      v-bind:style="{
                      color: statusColor(item.status)
                    }"
                  >brightness_1</v-icon>
                  {{ item.status }}
                </span>
              </template>
              <template v-slot:item.notifications="{ item }">
                <div style="text-align: center;">
                  <v-icon small :color="item.device_tokens && item.device_tokens.length > 0 ? '#2e7d32' : '#b0bec5'">
                    {{ item.device_tokens && item.device_tokens.length > 0 ? 'notifications_active' : 'notifications_off' }}
                  </v-icon>
                </div>
              </template>
              <template v-slot:item.is_admin="{ item }">
                <div class="admin-cell">
                  <v-simple-checkbox
                      :value="item.is_admin"
                      @input="switch_admin(item)"
                      color="primary"
                      :ripple="false"
                  ></v-simple-checkbox>
                  <v-tooltip v-if="item.user_role === 'vendor'" top content-class="compact-tooltip" nudge-top="-4">
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="admin-role-label">O</span>
                    </template>
                    <span>Owner</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>

            <v-divider class="ma-0" style="max-width: 1071px;margin-left: 13px!important;"></v-divider>
            <v-row class="fill-width" style="    margin-top: 20px !important;">
              <v-col class="pl-7 resume-list">
                <b
                    class="mr-4 medium-font"
                    style="font-weight: 500 !important;padding-right: 8px;"
                >Total:</b>
                <span class="color-gray">Active </span>
                <span class="color-cyan">{{ total_actives }}</span>
                <span class="color-gray mar_table">-</span>
                <span class="color-gray">Inactive </span>
                <span class="color-cyan">{{ total_inactives }}</span>

              </v-col>
            </v-row>
            <br/>
            <div class="text-center">

            </div>
          </v-card>
        </v-col>
      </v-row>

      <delete-modal
          :selected="selected"
          :show="showDeleteModal"
          :hide="hideDeleteModal"
          @setter="setter"
      ></delete-modal>
      <DeleteAllModal
          :show="showDeleteAllModal"
          :hide="hideDeleteAllModal"
      />
      <resend-modal :show="showResendModal" :hide="hideResendModal" :results="resendResults"/>
    </v-container>
  </v-content>
</template>

<script>
  import deleteModal from "./modals/delete";
  import DeleteAllModal from "@/views//modals/delete-all";
  import resendModal from "./modals/resend";
  import {mapState, mapActions} from "vuex";
  import {mask} from "vue-the-mask";
  import PaymentMixin from '@/mixins/payment';
  import {firestore} from "@/config/firebase";
  import SelectCheckbox from '@/components/SelectCheckbox.vue';

  export default {
    name: "VendorsList",
    mixins: [PaymentMixin],
    components: {
      "delete-modal": deleteModal,
      "resend-modal": resendModal,
      DeleteAllModal,
      SelectCheckbox
    },
    created() {
      if (this.$store.getters["Authenticate/isLoggedIn"]) {
        this.$store.dispatch("Banner/show");
        this.get_users("employee");
        this.initSubscriptions();
      } else {
        this.$router.push("/vendor/sign_up");
      }
    },
    props: {},
    directives: {
      mask,
    },
    computed: {
      ...mapState({
        total_actives: (state) => state.Vendors_list.total_actives,
        total_inactives: (state) => state.Vendors_list.total_inactives,
        dataUsers: state => state.Vendors_list.list_users,
        status: state => state.Vendors_list.status,
        user: state => state.Authenticate.user
      }),
      filteredItems() {
        if (!this.filters.status) {
          return this.dataUsers;
        }
        return this.dataUsers.filter(x => this.filters.status.toLowerCase() === x.status.toLowerCase());
      },
      allSelectedInactive() {
        return this.selected.length === 0 || this.selected.every(u => ['Deleted', 'Cancelled'].includes(u.status));
      }
    },
    data() {
      return {
        subscriptions: [],
        statuses: [
          {id: "", name: "All Users"},
          {id: "active", name: "Active Users"},
          {id: "Invited", name: "Invited Users"},
          {id: "Deleted", name: "Deleted Users"},
          {id: "Cancelled", name: "Cancelled Users"},
        ],
        filters: {
          status: ""
        },
        showDeleteAllModal: false,
        options: {
          itemsPerPage: -1
        },
        selected: [],
        showDeleteModal: false,
        showResendModal: false,
        resendResults: [],
        search: "",
        singleSelect: true,
        user_status: null,
        dataStatus: ['All', 'inactive', 'active'],
        headers: [
          {text: "NAME", value: "name", sortable: true, width: '200px'},
          {text: "EMAIL", value: "email", sortable: true, width: '260px'},
          {text: "PHONE", value: "phone_number", sortable: true, width: '150px'},
          {text: "STATUS", value: "status", sortable: true, width: '120px'},
          {text: "ALERTS", value: "notifications", sortable: true, width: '80px', align: 'center', cellClass: 'col-center'},
          {text: "ADMIN", value: "is_admin", sortable: true, width: '80px', align: 'center', cellClass: 'col-center'}
        ],
        mask: "### - ### - ####",
        error: false,
        message_error: null,
        list_agents: [],
        phone_selected: null,
        owner_selected: null,
      };
    },

    methods: {
      ...mapActions({get_users: "Vendors_list/get_users"}),
      statusColor(status) {
        let color = "";
        switch (status) {
          case "Active": {
            color = "#12d120";
            break;
          }
          case "Invited":
          case "Deleted":
          case "Cancelled":
          case "Onboarding":
          case "Inactive": {
            color = "#717e91";
            break;
          }
        }
        return color;
      },
      setter() {
        const self = this;
        self.selected = [];
      },
      show_DeleteModal() {
        if (this.selected.length === this.dataUsers.length) {
          this.showDeleteAllModal = true;
        } else {
          this.showDeleteModal = true;
        }
      },
      hideDeleteAllModal() {
        this.showDeleteAllModal = false;
      },
      hideDeleteModal() {
        this.showDeleteModal = false;
      },
      show_ResendModal() {
        const self = this;
        self.$store
          .dispatch("Vendors_list/resend_invite", {
            users: self.selected
          })
          .then(results => {
            self.resendResults = Array.isArray(results) ? results : [];
            self.showResendModal = true;
          });
      },
      hideResendModal() {
        this.showResendModal = false;
      },
      switch_admin(user) {
        const self = this;
        self.$store.dispatch("Vendors_list/switch_admin", user).then(() => {
        });
      },
      editItem(item) {
        const self = this;
        self.error = false;
        self.phone_selected = item.phone_number;
        self.owner_selected = item.owner_id;
      },
      saveItem(item) {
        const self = this;
        let new_phone_number = document.querySelector("#value_" + item.owner_id).value.replaceAll(' ', '').replaceAll('-', '');
        if (item.phone_number !== new_phone_number) {
          self.$store.dispatch("Vendors_list/update_phone_number", {
            new_phone_number: new_phone_number,
            phone_number: item.phone_number,
            owner_id: item.owner_id
          })
            .then((errorsCounter) => {
              if (errorsCounter !== null) {
                self.error = true;
                self.message_error = (errorsCounter && errorsCounter.message) ? errorsCounter.message : 'That number is already in use.';
                self.phone_selected = null;
                self.owner_selected = null;
              } else {
                self.phone_selected = null;
                self.owner_selected = null;
              }
            }).catch(error => {
            console.error(error);
          });


        } else {
          self.phone_selected = null;
          self.owner_selected = null;
        }
      },
      cancelItem() {
        const self = this;
        self.phone_selected = null;
        self.owner_selected = null;
        self.error = false;
      },
      initSubscriptions() {
        const self = this;
        self.subscriptions.push(firestore
          .collection("tenants")
          .doc(self.user.tenant_id)
          .collection("users")
          .where("user_role", "in", ["vendor", "employee"])
          .onSnapshot(snapshot => {
            for (const change of snapshot.docChanges()) {
              if (change.type === "modified") {
                const user = change.doc.data();
                user.id = change.doc.id;
                self.$store.commit("Vendors_list/updateUser", user);
              }
            }
          }, error => {
            console.error('[VendorUsersList] Tenant users listener error:', error);
          }));
      },
      unsubscribe() {
        for (const subscription of this.subscriptions) {
          subscription ? subscription() : '';
        }
      }
    },
    beforeDestroy() {
      this.unsubscribe();
    }
  };
</script>

<style scoped lang="scss">
  .custom-container {
    top: 40px;
    max-width: 1222px !important;
    min-height: 558px;
    margin-bottom: 50px !important;
  }

  .custom-o-white {
    height: 32px !important;
    width: 149px !important;
    top: 2px;
  }

  .top-container {
    margin-top: 0px;
  }

  .table_btn {
    color: #2bace2;
    font-size: 13px;
    font-weight: 400;
    text-transform: capitalize;
    letter-spacing: normal;
  }

  .table_botonera {
    padding: 15px 16px 20px;
  }

  .fill-width .mar_table {
    margin: 0 13px;
  }

  .admin-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .admin-role-label {
    position: absolute;
    left: calc(50% + 14px);
    font-size: 11px;
    font-weight: 600;
    color: #979797;
    cursor: default;
  }
</style>

<style lang="scss">
  .employees-table {
    .v-data-footer { border-top: none !important; }

    table {
      max-width: 1096px;
      table-layout: fixed;
      width: 100%;
      padding: 0 13px;
    }

    thead tr th {
      height: 48px !important;
      font-size: 11px !important;
      font-weight: 700 !important;
      text-transform: uppercase;
      font-family: Roboto, sans-serif !important;
      color: #979797 !important;
      white-space: nowrap;
      border-bottom: none !important;
      padding: 0 8px !important;

      .v-data-table-header__icon {
        color: #29ABE2 !important;
        margin-left: 4px;
        font-size: 16px !important;
        opacity: 0 !important;
      }

      &.active .v-data-table-header__icon {
        opacity: 1 !important;
      }

      span {
        position: static !important;
        top: auto !important;
        padding-right: 0 !important;
        line-height: normal !important;
        display: inline !important;
      }
    }

    tbody tr {
      box-shadow: inset 0 1px 0 rgba(0,0,0,0.08) !important;

      td {
        height: 48px !important;
        font-size: 13px;
        font-weight: 400;
        padding: 0 8px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

      }
    }

    th.text-center {
      text-align: center !important;
    }
    td.col-center {
      text-align: center !important;
      overflow: visible !important;
    }

    th:first-child, td:first-child {
      width: 48px !important;
      max-width: 48px !important;
    }
  }
</style>
